import { css } from 'styled-components';
import { TextInput } from '../TextInput/TextInput.js';
import { TextArea } from '../TextArea/TextArea.js';
import { SDS_SIZE_XXXXSMALL, SDS_SIZE_XXXSMALL, SDS_SIZE_XXSMALL, SDS_SIZE_XSMALL, SDS_SIZE_SMALL, SDS_SIZE_LARGE, SDS_SIZE_XXLARGE, SDS_SIZE_XXXXLARGE } from '@s-group/design-system-tokens/web/tokens/size.es6.js';

const nestedInputTopMargin = ({ sizing }) => sizing &&
    {
        xsmall: SDS_SIZE_XXXXSMALL,
        small: SDS_SIZE_XXXXSMALL,
        medium: SDS_SIZE_XXXSMALL,
        large: SDS_SIZE_XXXSMALL,
        xlarge: SDS_SIZE_XXSMALL,
    }[sizing];
const padding = ({ rounding, sizing }) => rounding === 'pill' &&
    sizing &&
    {
        xsmall: SDS_SIZE_XSMALL,
        small: SDS_SIZE_SMALL,
        medium: SDS_SIZE_LARGE,
        large: SDS_SIZE_XXLARGE,
        xlarge: SDS_SIZE_XXXXLARGE,
    }[sizing];
const margin = (props) => {
    const value = padding(props);
    return value ? `-${value}` : undefined;
};
const FormRowStyle = css `
    border: 0;
    margin: 0;
    padding: 0;
    padding-left: ${padding};

    ${TextArea},
    ${TextInput} {
        margin-left: ${margin};
    }

    > :not(:first-child) {
        margin-top: ${nestedInputTopMargin};
    }
`;

export { FormRowStyle };
//# sourceMappingURL=FormRow.styles.js.map
